import { render, staticRenderFns } from "./MenuItemVOD.vue?vue&type=template&id=4e23e7e8&scoped=true&"
import script from "./MenuItemVOD.vue?vue&type=script&lang=js&"
export * from "./MenuItemVOD.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemVOD.vue?vue&type=style&index=0&id=4e23e7e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e23e7e8",
  null
  
)

export default component.exports